import React,{ useEffect, useState } from 'react';
import Input from '../Common/Input';
import ReactSelect from 'react-select';
import { useEntityCrud } from '../../hooks/useEntityCrud';

const Form = ({ formik,hasParent }) => {

    console.log(hasParent);

    const [guilds,setGuilds] = useState([]);
    const {readData} = useEntityCrud('Guild/GetAllGuilds');

    const getData = () => {
        readData().then(({data}) => {
            if(data.status){
                let generateGuilds = [];
                data.result.map(item => {
                    generateGuilds.push({
                        label: item.title,
                        value: item.id
                    });
                })
                setGuilds(generateGuilds);
            }
        });
    }

    useEffect(() => {
        getData();
    },[]);

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="row">
                <div className="col-md-3">
                    <Input label="عنوان" name="title" required={true} formik={formik} />
                </div>
                <div className="col-md-2">
                    <div className="form-group">
                        <label>صنف والد</label>
                        <ReactSelect noOptionsMessage={e => 'یافت نشد'} placeholder="انتخاب کنید" options={guilds} value={guilds.filter(item => item.value == formik.values.guildId)} onChange={e => formik.setFieldValue('guildId', e.value)} />
                    </div>
                </div>
            </div>
            <button className="btn btn-success" id="btn-submit-form">ذخیره اطلاعات</button>
        </form>
    );
}

export default Form;